/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedPublishsetTagListResponse } from '../types/PaginatedPublishsetTagList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PublishsetTagsListRequest = {} | null | undefined;
export type PublishsetTagsListResponse = PaginatedPublishsetTagListResponse;

export type PublishsetTagsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/publishset_tags/
 *
 * ```yaml
 * operationId: publishset_tags_list
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPublishsetTagList'
 *     description: ''
 * ```
 */
export const publishsetTagsListOperation = (rest?: PublishsetTagsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/publishset_tags/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/publishset_tags/' };
  };

/**
 * GET /dmx-server/publishset_tags/
 *
 * ```yaml
 * operationId: publishset_tags_list
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPublishsetTagList'
 *     description: ''
 * ```
 */
export const publishsetTagsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PublishsetTagsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedPublishsetTagListResponse>> => {
  const operation = publishsetTagsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/publishset_tags/
 */
export const usePublishsetTagsListResource = (
  query: PublishsetTagsListQuery | null,
  useCached?: boolean,
): UseResource<PublishsetTagsListResponse> => {
  return useResource<PublishsetTagsListResponse>({
    path: query === null ? null : publishsetTagsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
